import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=6a36c17d&scoped=true&"
import script from "./protocol.vue?vue&type=script&lang=ts&"
export * from "./protocol.vue?vue&type=script&lang=ts&"
import style0 from "./protocol.vue?vue&type=style&index=0&id=6a36c17d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a36c17d",
  null
  
)

export default component.exports